const supportFeatures = [
  {
    icon: "ri-user-heart-line",
    title: "Atendimento humanizado, de verdade",
    desc: "Você nunca vai falar com um bot aqui. Cada dúvida, cada etapa do processo, tem uma pessoa real do nosso time respondendo com atenção e cuidado.",
    color: "bg-[#2563eb]",
  },
  {
    icon: "ri-focus-3-line",
    title: "Suporte personalizado para o seu caso",
    desc: "Nada de respostas prontas ou copy-paste. Entendemos a sua situação específica e te orientamos com base no que faz sentido para você e para o seu negócio.",
    color: "bg-[#0f2044]",
  },
  {
    icon: "ri-translate-2",
    title: "Em português, inglês ou espanhol",
    desc: "Nossa equipe atende nos três idiomas para que a barreira linguística nunca seja um obstáculo — afinal, você merece entender tudo o que está acontecendo.",
    color: "bg-[#2563eb]",
  },
];

export default function SupportSection() {
  return (
    <section className="bg-[#0f2044] py-20 px-4 md:px-8 overflow-hidden relative">
      <div className="absolute right-0 top-0 w-96 h-96 bg-[#2563eb]/15 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          {/* Left */}
          <div>
            <span className="text-[#60a5fa] text-sm font-semibold tracking-wider uppercase">Nosso atendimento</span>
            <h2 className="text-3xl md:text-4xl font-bold text-white mt-2 mb-4">
              Não somos uma empresa de{" "}
              <span className="text-[#60a5fa]">processos automatizados</span>
            </h2>
            <p className="text-white/60 text-base leading-relaxed mb-8">
              Somos um time de pessoas que escolheu trabalhar com contabilidade internacional porque acredita em fazer a diferença. Cada cliente recebe atenção individualizada — porque cada situação é única.
            </p>

            <div className="space-y-4">
              {supportFeatures.map((f, idx) => (
                <div key={idx} className="flex gap-4 items-start">
                  <div className={`w-10 h-10 flex items-center justify-center ${f.color} rounded-xl flex-shrink-0`}>
                    <i className={`${f.icon} text-white text-lg`} />
                  </div>
                  <div>
                    <h4 className="text-white font-semibold text-sm mb-1">{f.title}</h4>
                    <p className="text-white/50 text-sm leading-relaxed">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-10">
              <a
                href="#contato"
                className="inline-flex items-center gap-2 bg-[#2563eb] hover:bg-[#1d4ed8] text-white font-semibold px-6 py-3 rounded-full transition-colors cursor-pointer text-sm whitespace-nowrap"
              >
                Falar com especialista agora
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>

          {/* Right */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/66a509f24d4e69b9f77908f7593151a9.jpg"
                alt="Especialista de suporte ZB Consulting"
                className="w-full h-auto object-top rounded-2xl"
              />
            </div>

            {/* Chat bubble */}
            <div className="absolute bottom-6 left-6 bg-white rounded-2xl p-4 max-w-[220px]">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-7 h-7 bg-[#2563eb] rounded-full flex items-center justify-center">
                  <i className="ri-customer-service-2-line text-white text-xs" />
                </div>
                <div>
                  <p className="text-[10px] font-semibold text-[#0f2044]">Ana - ZB Advisor</p>
                  <div className="flex items-center gap-1">
                    <div className="w-1.5 h-1.5 bg-green-500 rounded-full" />
                    <span className="text-[9px] text-gray-400">Online agora</span>
                  </div>
                </div>
              </div>
              <p className="text-xs text-gray-600 leading-relaxed">
                &quot;Olá! Posso te ajudar a abrir sua empresa nos EUA hoje mesmo. Como posso te auxiliar?&quot;
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
